import React, { useMemo, useState, useContext } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import {
  Card,
  CardContent,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  InputAdornment,
  IconButton,
  Link
} from '@material-ui/core';

import { Visibility, VisibilityOff } from '@material-ui/icons';

import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

import { AuthContext } from "../../context/Auth/AuthContext";
import deskAdvisorLoginArt from "../../assets/branding/logo-desk-transp.png";

// const Copyright = () => {
// 	return (
// 		<Typography variant="body2" color="textSecondary" align="center">
// 			{"Copyleft "}
// 			<Link color="inherit" href="https://github.com/canove">
// 				Canove
// 			</Link>{" "}
// 			{new Date().getFullYear()}
// 			{"."}
// 		</Typography>
// 	);
// };

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(circle at 18% 12%, rgba(20, 184, 166, 0.22) 0%, rgba(15, 23, 42, 0.96) 34%, rgba(2, 6, 23, 1) 100%)"
        : "radial-gradient(circle at top, rgba(20, 184, 166, 0.12) 0%, rgba(241, 245, 249, 0.98) 42%, rgba(248, 250, 252, 0.98) 100%)",
    padding: theme.spacing(3, 2)
  },
  loginCard: {
    width: "100%",
    maxWidth: 720,
    borderRadius: 28,
    border:
      theme.palette.type === "dark"
        ? "1px solid rgba(45, 212, 191, 0.18)"
        : "1px solid rgba(15, 23, 42, 0.08)",
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(15, 23, 42, 0.96) 0%, rgba(8, 15, 29, 0.98) 100%)"
        : "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(248,251,252,0.98) 100%)",
    boxShadow:
      theme.palette.type === "dark"
        ? "0 34px 80px rgba(0, 0, 0, 0.48), 0 0 0 1px rgba(255,255,255,0.03) inset"
        : "0 30px 70px rgba(15, 23, 42, 0.10)"
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
  },
  logoWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 138,
    marginBottom: theme.spacing(3),
    overflow: "hidden",
    position: "relative",
    borderRadius: 24,
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(241,245,249,0.92) 100%)"
        : "transparent",
    border:
      theme.palette.type === "dark"
        ? "1px solid rgba(255,255,255,0.12)"
        : 0,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 18px 45px rgba(0,0,0,0.22)"
        : "none"
  },
  logoGlow: {
    display: "none"
  },
  logoAura: {
    display: "none"
  },
  logo: {
    position: "relative",
    width: "82%",
    maxWidth: 520,
    height: "auto",
    objectFit: "contain",
    objectPosition: "center",
    filter: "saturate(1.02) contrast(1.02) drop-shadow(0 14px 22px rgba(15, 23, 42, 0.08))"
  },
  headline: {
    fontWeight: 800,
    color: theme.palette.type === "dark" ? "#f8fafc" : theme.palette.text.primary,
    marginTop: theme.spacing(0.5)
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    borderRadius: 16,
    minHeight: 46,
    fontWeight: 700,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 16px 30px rgba(13, 148, 136, 0.24)"
        : "0 16px 30px rgba(15, 118, 110, 0.18)"
  },
  loginContent: {
    padding: theme.spacing(4, 4.5, 3)
  },
  blockedCard: {
    width: "100%",
    marginBottom: 24,
    borderRadius: 22,
    border:
      theme.palette.type === "dark"
        ? "1px solid rgba(251, 191, 36, 0.28)"
        : "1px solid rgba(196, 150, 58, 0.24)",
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(69, 47, 11, 0.92) 0%, rgba(30, 41, 59, 0.96) 100%)"
        : "linear-gradient(180deg, rgba(255, 249, 232, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)",
    boxShadow:
      theme.palette.type === "dark"
        ? "0 20px 45px rgba(0, 0, 0, 0.30)"
        : "0 20px 45px rgba(37, 50, 70, 0.08)"
  },
  blockedReason: {
    color: theme.palette.type === "dark" ? "#fde68a" : "#8b5e12",
    fontWeight: 600,
    marginBottom: 10
  },
  blockedDescription: {
    color:
      theme.palette.type === "dark"
        ? "rgba(248, 250, 252, 0.78)"
        : "rgba(15, 23, 42, 0.72)",
    lineHeight: 1.6
  },
  blockedSupportBox: {
    marginTop: 18,
    borderRadius: 14,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(251, 191, 36, 0.14)"
        : "rgba(250, 204, 21, 0.12)",
    border:
      theme.palette.type === "dark"
        ? "1px solid rgba(251, 191, 36, 0.24)"
        : "1px solid rgba(196, 150, 58, 0.18)",
    color: theme.palette.type === "dark" ? "#fef3c7" : "#7c5a17",
    padding: "12px 14px",
    fontSize: 14,
    lineHeight: 1.5
  }
}));

const Login = () => {
  const classes = useStyles();
  const location = useLocation();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showBlockedNotice, setShowBlockedNotice] = useState(true);

  const { handleLogin } = useContext(AuthContext);

  const blockedCompany = useMemo(() => {
    if (location.state?.blockedCompany) {
      return location.state.blockedCompany;
    }

    const storedBlockedCompany = window.sessionStorage.getItem("companyAccessBlocked");

    if (!storedBlockedCompany) {
      return null;
    }

    try {
      return JSON.parse(storedBlockedCompany);
    } catch (error) {
      return null;
    }
  }, [location.state]);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  const handleDismissBlockedNotice = () => {
    window.sessionStorage.removeItem("companyAccessBlocked");
    setShowBlockedNotice(false);
  };

  return (
    <Box className={classes.page}>
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Card elevation={0} className={classes.loginCard}>
          <CardContent className={classes.loginContent}>
            <div className={classes.paper}>
              {blockedCompany && showBlockedNotice && (
                <Card
                  elevation={0}
                  className={classes.blockedCard}
                >
                  <CardContent style={{ padding: 24 }}>
                    <Typography
                      component="h2"
                      variant="h6"
                      style={{ fontWeight: 700, marginBottom: 8 }}
                    >
                      {blockedCompany.title || "Acesso bloqueado"}
                    </Typography>
                    <Typography
                      variant="body1"
                      className={classes.blockedReason}
                    >
                      {blockedCompany.reason}
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.blockedDescription}
                    >
                      {blockedCompany.description}
                    </Typography>
                    <Box
                      component="div"
                      className={classes.blockedSupportBox}
                    >
                      Entre em contato com o suporte para regularizar o acesso.
                    </Box>
                    <Box mt={2}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleDismissBlockedNotice}
                      >
                        Acessar com outra conta
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              )}

              <div className={classes.logoWrapper}>
                <div className={classes.logoGlow} />
                <div className={classes.logoAura} />
                <img
                  src={deskAdvisorLoginArt}
                  alt="AltChat"
                  className={classes.logo}
                />
              </div>

              <Typography component="h1" variant="h5" className={classes.headline}>
                {i18n.t("login.title")}
              </Typography>
              <form className={classes.form} noValidate onSubmit={handlSubmit}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={i18n.t("login.form.email")}
                  name="email"
                  value={user.email}
                  onChange={handleChangeInput}
                  autoComplete="email"
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label={i18n.t("login.form.password")}
                  id="password"
                  value={user.password}
                  onChange={handleChangeInput}
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((e) => !e)}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  {i18n.t("login.buttons.submit")}
                </Button>
                <Grid container>
                  <Grid item>
                    <Link
                      href="#"
                      variant="body2"
                      component={RouterLink}
                      to="/signup"
                    >
                      {i18n.t("login.buttons.register")}
                    </Link>
                  </Grid>
                </Grid>
              </form>
            </div>
          </CardContent>
        </Card>
        <Box mt={4}>{/* <Copyright /> */}</Box>
      </Container>
    </Box>
  );
};

export default Login;
